import _ from 'lodash'
import { bus } from '../../utils'

export default {
  name: 'TimelineLog',
  computed: {
    isEmpty () {
      return Array.isArray(this.logList) && _.isEmpty(this.logList)
    }
  },
  data () {
    return {
      hasLocation: {},
      status: {}
    }
  },
  methods: {
    getGeoIP: _.memoize(function (ip) {
      return this.$api.getGeoip(ip)
    }),
    getLogs: _.memoize(function (time, identity, fields) {
      const query = {
        args: JSON.stringify({
          tags: this.tagsFormat(identity),
          metrics: fields,
          limit: 1,
          end_time: +new Date(time) + 1,
          fill: 'previous'
        })
      }
      return this.$api.getLogs(query)
    }),
    getDevice: _.memoize(function (identity) {
      return this.$api.getDevices({ identity })
    }),
    async getInfo (index, identity, time, ip, deviceID) {
      let fields = this.fields

      if (this.$route.name === 'User List') {
        fields = await this.getDevice(deviceID)
          .then(({body}) => body.devices[0].fields)
      }

      const location = await this.getGeoIP(ip)
      const logs = await this.getLogs(time, identity, fields)
          .then(({ body }) => _(body.columns)
            .zipObject(body.values[0])
            .omit('time')
            .mapValues(value => value == null ? '--' : value)
            .value()
          )

      this.hasLocation[index] = {
        regionName: location.region_name,
        countryName: location.country_name,
        content: logs
      }

      const regionName = this.hasLocation[index].regionName
      const countryName = this.hasLocation[index].countryName
      const content = this.hasLocation[index].content
      const indexStatus = {
        countryName,
        ip,
        content,
        regionName
      }

      this.status = Object.assign({}, this.status, {
        [index]: indexStatus
      })
    },
    getMatchedOperator (op) {
      if (!op) { console.error('Operation is required.') }

      const operators = {
        eq: '=',
        gt: '>',
        geq: '≥',
        lt: '<',
        leq: '≤',
        neq: '≠'
      }

      if (!operators[op]) {
        console.error('No matched operation found.')
      }
      return operators[op]
    },
    getConditionStatus (conditions) {
      const result = conditions
        .map(({key, op, target}) => `${key}${this.getMatchedOperator(op)}${target}`)
        .join(', ')

      return `(${result})`
    },
    getContent (action) {
      const { content, notification } = action
      if (content) {
        return content
      } else if (notification) {
        return notification.title
      }

      return ''
    },
    hideModel () {
      bus.$emit('hide-timeline-model')
    },
    fromWhom ({ action }) {
      const { path } = this.$route
      if (path.includes('/device')) {
        return action.email
      }
      if (path.includes('/user')) {
        return action.device_unique_id || action.sn
      }
      return ''
    },
    logType (type) {
      const tag = {
        debug: {
          color: 'info',
          label: this.$t('LogType.DEBUG')
        },
        error: {
          color: 'danger',
          label: this.$t('LogType.ERROR')
        },
        event: {
          color: 'success',
          label: this.$t('LogType.EVENT')
        }
      }
      return tag[type]
    },
    moreMessage (action) {
      return 'key' in action
        ? `(${action.key}: ${action.value})`
        : 'value' in action
        ? `(${action.value})`
        : ''
    },
    navigate ({ action }) {
      let { path } = this.$route
      if (path.includes('/device')) {
        return `/user/${action.email}`
      }
      if (path.includes('/user')) {
        const id = action.device_unique_id || action.sn
        return `/device/${id}`
      }
      return ''
    },
    tagsFormat (target) {
      return _.includes(target, '@') ? { email: target, log_type: 'event' } : { device_id: target }
    }
  },
  props: {
    fields: {
      type: Array,
      default: () => []
    },
    logList: {
      required: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/TimelineLog/TimelineLog.js